import P from '@hero/ui-kit/typography/P';
import * as React from 'react';
import { formatDateTime, normalizeDateString } from '@hero/hero-utils/date';
import { ProspectSmsLog } from '../../types';
import * as styles from './style.module.css';

interface SmsLogListProps {
    logs: ProspectSmsLog[];
}

const SmsLogList: React.FC<SmsLogListProps> = ({ logs }) => {
    const preparedArray = React.useMemo(() => {
        if (!logs?.length) {
            return [];
        }

        return [...logs].sort((a, b) => {
            return new Date(b.created_at || '').getTime() - new Date(a.created_at || '').getTime();
        });
    }, [logs]);

    if (!preparedArray.length) {
        return <P noDefaultMargin>No SMS logs available.</P>;
    }

    return (
        <>
            <div className={styles.container}>
                {preparedArray.map((log, index) => {
                    const isAgentMessage = Boolean(log.crm_agent);
                    const displayName = isAgentMessage
                        ? (log.crm_agent ?? 'CRM Agent')
                        : (log.phone ?? 'Prospect');
                    const directionLabel = log.inbound ? 'Received' : 'Sent';
                    const timestamp = log.created_at
                        ? formatDateTime(normalizeDateString(log.created_at, true))
                        : 'N/A';

                    const messageClasses = [styles.bubble];

                    const content = log.message?.trim();

                    if (!content) {
                        messageClasses.push(styles.emptyMessage);
                    }

                    return (
                        <div
                            key={`${log.created_at}-${index}`}
                            className={`${styles.messageRow} ${
                                isAgentMessage ? styles.agent : styles.prospect
                            }`}
                        >
                            <div>
                                <P noDefaultMargin className={messageClasses.join(' ')}>
                                    {content || 'No message provided'}
                                </P>
                                {isAgentMessage ? (
                                    <span className={styles.agentTimestamp}>
                                        {displayName} - {timestamp}
                                    </span>
                                ) : null}
                            </div>

                            <div className={styles.meta} title={displayName}>
                                <span className={styles.metaText}>{displayName}</span>
                                <span className={styles.dot} aria-hidden="true">
                                    •
                                </span>
                                <span className={styles.metaText}>{directionLabel}</span>
                                {!isAgentMessage ? (
                                    <>
                                        <span className={styles.dot} aria-hidden="true">
                                            •
                                        </span>
                                        <span className={styles.metaText}>{timestamp}</span>
                                    </>
                                ) : null}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default SmsLogList;
